import { useQuery } from "@tanstack/react-query";
import { UsersManagement, WorkOsWidgets } from "@workos-inc/widgets";
import { Alert } from "react-bootstrap";

import { AASpinner, useAATheme } from "@bagel-web/components";

import "@radix-ui/themes/styles.css";
import "@workos-inc/widgets/styles.css";
import { CommonAPI } from "../types";
import { queries } from "..";

const UserList = ({ commonAPI }: { commonAPI: CommonAPI }) => {
  const {
    isPending: isWidgetTokenPending,
    isError: isWidgetTokenError,
    data: widgetToken,
    error: widgetTokenError,
  } = useQuery({
    queryKey: queries.widgetTokenQueries.getUserTableWidgetToken(),
    queryFn: () => commonAPI.fetchUsersWidgetToken(),
  });

  const { isDarkMode } = useAATheme();

  if (isWidgetTokenPending) {
    return <AASpinner />;
  } else if (isWidgetTokenError || !widgetToken?.token) {
    return (
      <Alert variant="warning">
        {`Could not load users: ${widgetTokenError?.message || "Invalid permissisons"}.`}
      </Alert>
    );
  } else if (widgetToken?.token) {
    return (
      <WorkOsWidgets
        theme={{
          appearance: isDarkMode ? "dark" : "light",
          hasBackground: false,
        }}
      >
        <UsersManagement authToken={widgetToken.token} />
      </WorkOsWidgets>
    );
  }
};

export default UserList;
